import { LEGEND_SECTIONS } from "../statusStyles";

/*
 * The legend.
 *
 * The statuses hidden from the legend, and whether the legend is collapsed,
 * are remembered per browser (for every node, like the zoom: which statuses
 * someone wants to see is theirs, not the node's). Storage can be blocked
 * inside an iframe, which just means the matrix opens with the defaults.
 */
export const HIDDEN_STATUSES_STORAGE_KEY = "matrix.hiddenStatuses";
export const LEGEND_COLLAPSED_STORAGE_KEY = "matrix.legendCollapsed";

export const LEGEND_STATUSES = LEGEND_SECTIONS.flatMap(
  ({ statuses }) => statuses,
);

// Until someone changes it, cancelled bookings are hidden.
const DEFAULT_HIDDEN = ["cancelled"];

export const readHiddenStatuses = () => {
  try {
    const stored = JSON.parse(
      window.localStorage.getItem(HIDDEN_STATUSES_STORAGE_KEY),
    );
    return Array.isArray(stored)
      ? stored.filter((status) => LEGEND_STATUSES.includes(status))
      : DEFAULT_HIDDEN;
  } catch {
    return DEFAULT_HIDDEN;
  }
};

export const storeHiddenStatuses = (statuses) => {
  try {
    window.localStorage.setItem(
      HIDDEN_STATUSES_STORAGE_KEY,
      JSON.stringify(statuses),
    );
  } catch {
    // Not persisted; the statuses are still hidden for this visit.
  }
};

// The statuses whose blocks are drawn. Unassigned seats are not in the legend
// and always are.
export const visibleStatuses = (hidden) =>
  ["unassigned", ...LEGEND_STATUSES].filter(
    (status) => !hidden.includes(status),
  );

export const hiddenStatuses = (visible) =>
  LEGEND_STATUSES.filter((status) => !visible.includes(status));

export const readLegendCollapsed = () => {
  try {
    return window.localStorage.getItem(LEGEND_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const storeLegendCollapsed = (collapsed) => {
  try {
    window.localStorage.setItem(
      LEGEND_COLLAPSED_STORAGE_KEY,
      String(collapsed),
    );
  } catch {
    // Not persisted; the legend still collapses for this visit.
  }
};
